/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authenticatorsCreate } from "../../funcs/authenticatorsCreate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateAuthenticatorPayload$inboundSchema,
};

export const tool$authenticatorsCreate: ToolDefinition<typeof args> = {
  name: "authenticators-create",
  description: `Create Authenticator

Create White labeled connector credentials`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authenticatorsCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
